// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1bwyh","inputDescription":"styles_inputDescription__x4k4g"};